import {
  Component,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  input,
  output,
  viewChild
} from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';

import { NotificationsToast, NotificationsToastComponent } from '../notifications-toast.domain';

@Component({
  selector: 'td-wb-notification-toast-wrapper',
  templateUrl: './notification-toast-wrapper.component.html',
  styleUrls: ['./notification-toast-wrapper.component.scss']
})
export class NotificationToastWrapperComponent implements OnInit, OnDestroy {

  readonly toast = input<NotificationsToast>(undefined);
  readonly expiryDuration = input<number>(undefined);
  readonly excessMessageCount = input<number>(undefined);
  readonly onClose = output<NotificationsToast>();

  readonly viewContainerRef = viewChild('dynamic', { read: ViewContainerRef });

  private componentRef: ComponentRef<NotificationsToastComponent>;
  private timer: ReturnType<typeof setTimeout>;

  constructor() { }

  /**
   * Init
   * Create toast component
   * Set up close time
   */
  ngOnInit(): void {
    const expiryDuration = this.expiryDuration();
    if(expiryDuration) {
      this.timer = setTimeout((): void => {
        this.close();
      }, expiryDuration);
    }

    const toast = this.toast();
    if (toast.componentType !== undefined) {
      this.componentRef = this.viewContainerRef().createComponent(toast.componentType);
      this.setupComponent(this.componentRef);
      this.viewContainerRef().insert(this.componentRef.hostView);
    }
  }

  /**
   * Destroy
   */
  ngOnDestroy(): void {
    this.componentRef?.destroy();
    clearTimeout(this.timer);
  }

  /**
   * close notification toast
   */
  close(): void {
    this.onClose.emit(this.toast());
  }

  /**
   * Setup toast component
   */
  private setupComponent(componentRef: ComponentRef<NotificationsToastComponent>): void {
    // Use setInput so signal-based child inputs receive the values correctly.
    componentRef.setInput('toast', this.toast());
    if (componentRef.instance.excessMessageCount !== undefined) {
      componentRef.setInput('excessMessageCount', this.excessMessageCount());
    }
    const instance = componentRef.instance;
    if (instance.onClose !== undefined) {
      outputToObservable(instance.onClose).subscribe((): void => {
        this.close();
      });
    }
  }
}
